import { DownloadIcon, GcpBox, GcpTypography } from '@back-office/ui';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert from '@material-ui/lab/Alert';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PAYMENT_MAKER_PERMISSION } from '../../constants';
import DragAndDrop from '../payment-file/DragAndDrop';
import TabsPaymentFile from '../payment-file/TabsPaymentFile';
import Transaction from '../payment-file/Transactions';
import UploadLogs from '../payment-file/UploadLogs';
import useViewModel from './viewmodel';

export interface UploadOptions {
  scheduleDate: string;
  isProcessingNow: boolean;
}

export const useStyles = makeStyles(() => ({
  alert: {
    justifyContent: 'center',
    margin: '16px 0',
  },
}));

const PaymentFile: FC = observer(() => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    handleChange,
    handleUploadFile,
    hasViewAndCheckerPermission,
    selectTab,
    uploaded,
    failedAlert,
    auth,
  } = useViewModel();

  return (
    <GcpBox style={{ maxWidth: '1096px' }}>
      <Grid container>
        <Grid container item alignItems="center" xs={3}>
          <GcpTypography variant="h3">{t('payment_file.list')}</GcpTypography>
        </Grid>
        {!hasViewAndCheckerPermission && (
          <Grid item xs={9}>
            <GcpBox display="flex" gap={2} justifyContent="flex-end">
              <Link
                download
                target="_blank"
                to="/assets/resources/recurring-template.xlsx"
              >
                <Button
                  size="large"
                  startIcon={<DownloadIcon />}
                  type="button"
                  variant="outlined"
                >
                  {t('payment_file.template')}
                </Button>
              </Link>
            </GcpBox>
          </Grid>
        )}
      </Grid>
      {(auth.currentUser.role === 'ADMIN' ||
        auth.currentUser.permissions?.includes(PAYMENT_MAKER_PERMISSION)) && (
        <GcpBox mb={3} mt={3}>
          {failedAlert && (
            <Alert className={classes.alert} icon={false} severity="error">
              <GcpTypography variant="body1">{failedAlert}</GcpTypography>
            </Alert>
          )}
          <DragAndDrop onUpload={handleUploadFile} />
        </GcpBox>
      )}
      <GcpBox mb={3} mt={3}>
        <TabsPaymentFile
          handleChange={(_, newValue) => handleChange(newValue)}
          items={['upload_logs', 'transactions']}
          value={selectTab}
        />
      </GcpBox>
      {selectTab === 0 && <UploadLogs uploaded={uploaded} />}
      {selectTab === 1 && <Transaction />}
    </GcpBox>
  );
});

export default PaymentFile;
